import Card from 'components/card';
import { ReactNode } from 'react';

const Widget = (props: { icon: JSX.Element; title: ReactNode; subtitle: ReactNode }) => {
  const { icon, title, subtitle } = props;
  return (
    <Card extra="!flex-row flex-grow items-center rounded-[10px] pr-[20px]">
      <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
        <div className="rounded-full bg-lightPrimary p-3">
          <span className="flex items-center text-brand-500">{icon}</span>
        </div>
      </div>

      <div className="h-50 ml-4 flex w-auto flex-col justify-center">
        <p className="font-dm text-sm font-medium text-gray-600">{title}</p>
        <h4 className="text-xl font-bold text-navy-700">{subtitle}</h4>
      </div>
    </Card>
  );
};

export default Widget;
